import React from 'react'
import _ from 'lodash'
import { Table, Pagination } from 'semantic-ui-react'

import OrderListItem from './OrderListItem'

const numberPerPage = 15

export default class OrderList extends React.PureComponent {
  renderHeader = () => {
    const HEADERS = [
      { col: 'Customer', width: '12%', align: 'left' },
      { col: 'Restaurant', width: '15%', align: 'left' },
      { col: 'Items', width: '25%', align: 'left' },
      { col: 'Payment', width: '13%', align: 'center' },
      { col: 'Driver', width: '10%', align: 'center' },
      { col: 'Ordered At', width: '10%', align: 'center' },
      { col: 'Status/Actions', width: '15%', align: 'center' },
    ]

    return (
      <Table.Row>
        {HEADERS.map(header => (
          <Table.HeaderCell style={{ width: header.width }} textAlign={header.align} key={header.col}>
            {header.col}
          </Table.HeaderCell>
        ))}
      </Table.Row>
    )
  }

  isReadOnlyOrder = order => {
    const { currentOperator } = this.props

    return !currentOperator.isOperatorAdmin && currentOperator.uid !== order.current_operator
  }

  renderBody = orders => {
    const {
      delivereeInProgressOrders,
      delivererInProgressOrders,
      driversGroupByPackage,
      showModalPackage,
      showCancelReasons,
      showEditNote,
      showReserve,
      showManualAssign,
      showOrderMap,
      showMerchantMapWithDrivers,
      showLiveTracking,
      showSwitchDriver,
      showEditItems,
      regions,
      onOpenRefundModal,
      saveRefundTo,
      lastEditedOrder
    } = this.props

    if (orders.length === 0)
      return (
        <Table.Row key="no-result">
          <Table.Cell colSpan={8} textAlign="center">
            No results
          </Table.Cell>
        </Table.Row>
      )

    return orders.map(order => (
      <OrderListItem
        key={order.key}
        order={order}
        region={regions[order.region]}
        readOnly={this.isReadOnlyOrder(order)}
        inProgressOrders={
          delivereeInProgressOrders[order.deliveree] ? delivereeInProgressOrders[order.deliveree].length : 0
        }
        delivererInProgressOrders={(order.deliverer && delivererInProgressOrders[order.deliverer]) || []}
        showModalPackage={() => showModalPackage(order)}
        showCancelReasons={forceCancel => showCancelReasons(order, forceCancel)}
        showEditNote={() => showEditNote(order)}
        showReserve={() => showReserve(order)}
        showManualAssign={() => showManualAssign(order)}
        showOrderMap={() => showOrderMap(order)}
        showMerchantMapWithDrivers={() => showMerchantMapWithDrivers(order)}
        showLiveTracking={() => showLiveTracking(order)}
        driversGroupByPackage={driversGroupByPackage}
        showSwitchDriver={data => showSwitchDriver(data)}
        showEditItems={() => showEditItems(order)}
        onOpenRefundModal={() => onOpenRefundModal(order)}
        saveRefundTo={saveRefundTo}
        lastEditedOrder={lastEditedOrder}
      />
    ))
  }

  render() {
    const { orders = [], currentPage, onChangePage } = this.props

    const pageSize = Math.ceil(orders.length / numberPerPage)

    const begin = (currentPage - 1) * numberPerPage
    const end = begin + numberPerPage

    const pageOrdersData = _.slice(orders, begin, end)

    return (
      <Table basic selectable>
        <Table.Header>{this.renderHeader()}</Table.Header>
        <Table.Body>
          {this.renderBody(pageOrdersData)}
          {pageSize > 0 && (
            <Table.Row>
              <Table.HeaderCell colSpan="8" style={{ padding: 10 }}>
                <Pagination
                  activePage={currentPage}
                  onPageChange={onChangePage}
                  floated="right"
                  totalPages={pageSize}
                />
              </Table.HeaderCell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderList.js